<template>
  <div>
    <h3>{{ getDisplayname() }}</h3>
  </div>
  <div class="card" style="margin: 10px 10px">
    <div class="flex flex-wrap card-container align-items-center justify-content-center">
      <div style="width: 1200px">
        <div
          class="flex flex-wrap card-container align-items-center justify-content-center"
        >
          <div
            v-for="recordFieldDescription in recordFieldDescriptions"
            v-bind:key="recordFieldDescription.name + ':' + Math.random()"
          >
            <RecordField
              v-model:record="record"
              :recordFieldDescription="recordFieldDescription"
              :editMode="true"
              :disabled="isFieldDisabled(recordFieldDescription.name)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <Dialog
    v-model:visible="duplicateDialogVisible"
    modal
    style="width: 640px; max-width: 95vw"
  >
    <template #header>
      <h3 style="margin: 0">Ansprechpartner gibt es möglicherweise schon</h3>
    </template>
    <div v-for="duplicate in duplicates" :key="duplicate.id" class="duplicate">
      <div class="duplicate-name">
        {{ duplicate.name }}
        <span class="duplicate-score">{{ duplicate.score }} %</span>
      </div>
      <div class="duplicate-details">{{ details(duplicate) }}</div>
      <div class="duplicate-reasons">{{ duplicate.reasons.join(", ") }}</div>
      <Button
        label="Vorhandenen öffnen"
        icon="pi pi-external-link"
        class="p-button-sm"
        @click="openContactPerson(duplicate.id)"
      />
    </div>
    <template #footer>
      <Button
        label="Abbrechen"
        severity="secondary"
        icon="pi pi-times"
        @click="duplicateDialogVisible = false"
      />
      <Button
        label="Trotzdem anlegen"
        severity="warning"
        icon="pi pi-user-plus"
        @click="saveIgnoringDuplicates()"
      />
    </template>
  </Dialog>
</template>

<script>
import ServerConnection from "../../services/ServerConnection/ServerConnection";
import FailureHandler from "../../services/ServerConnection/FailureHandler";
import { useMenuService } from "../../services/MenuService/UseMenuService";
import {
  loadContactPersonDuplicates,
  contactPersonDuplicateDetails,
} from "../../services/ContactPersonService/ContactPersonDuplicates";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import RecordField from "./RecordField";
import { locationFieldDescriptions } from "./descriptions/location";
import { contactpersonFieldDescriptions } from "./descriptions/contactperson";
import { teamFieldDescriptions } from "./descriptions/team";
import { associationFieldDescriptions } from "./descriptions/association";
export default {
  name: "NewRecordView",
  components: {
    RecordField,
    Dialog,
    Button,
  },
  props: {
    recordType: String,
    fieldsList: {
      type: Array,
      required: false,
    },
    disabledFields: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      record: {},
      menuService: useMenuService(),
      duplicates: [],
      duplicateDialogVisible: false,
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    recordFieldDescriptions() {
      var fieldDescriptions = [];
      switch (this.recordType) {
        case "team":
          fieldDescriptions = teamFieldDescriptions;
          break;
        case "location":
          fieldDescriptions = locationFieldDescriptions;
          break;
        case "contactperson":
          fieldDescriptions = contactpersonFieldDescriptions;
          break;
        case "association":
          fieldDescriptions = associationFieldDescriptions;
          break;
        default:
          throw new Error("invalid record type " + this.recordType);
      }
      if (this.fieldsList && this.fieldsList.length > 0) {
        return fieldDescriptions.filter(
          (fd) => this.fieldsList.filter((fieldName) => fieldName == fd.name).length > 0
        );
      }
      return fieldDescriptions;
    },
  },
  created() {
    if (!this.loggedIn) {
      this.$router.push("/login");
    }
    this.updateMenus();
  },
  watch: {
    loggedIn(newValue) {
      if (!newValue) {
        this.$router.push("/login");
      }
    },
  },
  methods: {
    updateMenus() {
      var sidebarItems = [];
      this.menuService.setSidebarItems(sidebarItems);
      this.menuService.setMainMenuItemNames([
        "home",
        {
          name: "save",
          command: async () => {
            if (await this.showsDuplicateWarning()) {
              return;
            }
            await this.saveAndOpenRecord();
          },
        },
        {
          name: "cancel",
          command: () => {
            this.$router.go(-1);
          },
        },
      ]);
    },

    async showsDuplicateWarning() {
      if (this.recordType != "contactperson" || !this.record.name) {
        return false;
      }
      try {
        this.duplicates = await loadContactPersonDuplicates(this.record);
      } catch (error) {
        this.duplicates = [];
      }
      this.duplicateDialogVisible = this.duplicates.length > 0;
      return this.duplicateDialogVisible;
    },
    async saveIgnoringDuplicates() {
      this.duplicateDialogVisible = false;
      await this.saveAndOpenRecord();
    },
    async saveAndOpenRecord() {
      const savedRecord = await this.saveRecord();
      if (savedRecord && savedRecord.id) {
        this.$router.push("/recordview/" + this.recordType + "/" + savedRecord.id);
      }
    },
    openContactPerson(contactPersonId) {
      this.duplicateDialogVisible = false;
      this.$router.push("/recordview/contactperson/" + contactPersonId);
    },
    details(duplicate) {
      return contactPersonDuplicateDetails(duplicate);
    },
    async saveRecord() {
      try {
        const response = await ServerConnection.post("data/" + this.recordType, this.record);
        if (response.status != 201) {
          throw response;
        }
        this.record = response.data;
        return this.record;
      } catch (error) {
        FailureHandler.handleServerFailure(this.$router, error);
      }
      return null;
    },
    isFieldDisabled(recordFieldName) {
      if (this.disabledFields) {
        return (
          this.disabledFields.filter((disabledField) => disabledField == recordFieldName)
            .length > 0
        );
      }
      return false;
    },
    getDisplayname() {
      switch (this.recordType) {
        case "team":
          return "Neue Mannschaft";
        case "location":
          return "Neuer Spielort";
        case "contactperson":
          return "Neuer Ansprechpartner";
        default:
          return "Unbekannt";
      }
    },
  },
};
</script>

<style scoped>
.duplicate {
  padding: 6px 0;
  border-top: 1px solid #f0e0b0;
}
.duplicate:first-of-type {
  border-top: none;
}
.duplicate-name {
  font-weight: bold;
}
.duplicate-score {
  font-weight: normal;
  color: #7a6a3a;
}
.duplicate-details,
.duplicate-reasons {
  font-size: 0.9em;
  color: #6b6b6b;
  margin-bottom: 4px;
}
</style>
